/* One Kickz · extraído de snippets/ok-col-filterbar.liquid (19/10/2026) */
(function () {
    var ES = /^es/i.test(document.documentElement.lang || '');
    var NAMES = !ES ? {} : { size: 'Talle', talle: 'Talle', categoria: 'Categoría', marca: 'Marca', precio: 'Precio', color: 'Color', disponibilidad: 'Disponibilidad' };
    var SIZE_LIKE = /talle|size|tama/i;
    // "4us(23cm)" -> "4 US" arriba y "23 cm" abajo
    var SPLIT = /^\s*([\d.,]+)\s*([a-z]{1,3})?\s*\(([^)]+)\)\s*$/i;
    function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
    var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
    var SLIDERS = '<svg class="ok-fico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2.2"/><circle cx="9" cy="17" r="2.2"/></svg>';
    var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    var pop, scrim, openIdx = -1, openBtn = null;

    function form() { return document.querySelector('.section-collection facet-filters-form.collection-facets:not(.facets__sorting)'); }
    function sections() { var f = form(); return f ? Array.prototype.slice.call(f.querySelectorAll('details.facets__accordion-section')) : []; }
    function title(sec) {
      var s = sec.querySelector('summary');
      var t = s ? (s.firstChild && s.firstChild.nodeType === 3 ? s.firstChild.textContent : s.textContent) : '';
      t = t.replace(/\s+/g, ' ').trim();
      return NAMES[t.toLowerCase()] || t;
    }
    function boxes(sec) { return Array.prototype.slice.call(sec.querySelectorAll('input[type="checkbox"]')); }
    function labelOf(input) {
      var l = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      return ((l || input.parentElement).textContent || input.value).replace(/\s+/g, ' ').trim();
    }

    // Precio: el tema completa mínimo y máximo, así que se toma como activo solo si figura en la dirección
    function rangeOn(sec) {
      var q = new URLSearchParams(location.search);
      var nums = sec.querySelectorAll('input[type="number"][name]');
      for (var i = 0; i < nums.length; i++) if (q.get(nums[i].name)) return true;
      return false;
    }

    function headerOffset() {
      var h = document.querySelector('header.shopify-section, .section-header');
      var top = 0;
      if (h) {
        var cs = getComputedStyle(h);
        // 21/10/2026: altura del header ya fijado (constante), no su posición actual (ver ok-col-mobile).
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          // 21/10/2026: se pega debajo de la tarjeta blanca del header (no del bloque con su margen), igual que ok-theme.js.
          var card = h.querySelector('.header.js-header');
          var hb = card ? card.getBoundingClientRect().bottom - h.getBoundingClientRect().top : h.getBoundingClientRect().height;
          top = Math.max(0, Math.round(hb + (parseFloat(cs.top) || 0)) - 1);
        }
      }
      document.documentElement.style.setProperty('--ok-hdr', top + 'px');
      stuck(top);
    }

    // Detecta cuándo la barra queda pegada; compensa la fila de categorías que se oculta para que la página no salte
    function stuck(top) {
      var f = form();
      if (!f || getComputedStyle(f).position !== 'sticky') return;
      var r = f.getBoundingClientRect();
      var on = window.scrollY > 0 && r.top <= top + 1;
      if (on === f.classList.contains('ok-stuck')) return;
      if (on) {
        var cb = f.querySelector('.ok-catbar');
        var h = cb ? cb.offsetHeight + 8 : 0;
        var before = f.offsetHeight;
        f.classList.add('ok-stuck');
        f.style.marginBottom = Math.max(0, before - f.offsetHeight) + 'px';
      } else {
        f.classList.remove('ok-stuck');
        f.style.marginBottom = '';
      }
    }

    function build() {
      var f = form();
      if (!f) return;
      var inner = f.querySelector('.collection-facets__inner');
      if (!inner) return;
      inner.classList.add('ok-fb');

      // Botón Filtros con ícono y cantidad de filtros activos
      var fbtn = inner.querySelector('.facets__button-filters');
      if (fbtn && !fbtn.querySelector('.ok-fico')) fbtn.insertAdjacentHTML('afterbegin', SLIDERS);
      var active = 0;
      sections().forEach(function (sec) {
        var on = boxes(sec).filter(function (b) { return b.checked; }).length;
        if (!boxes(sec).length && rangeOn(sec)) on = 1;
        active += on;
      });
      if (fbtn) {
        var c = fbtn.querySelector('.ok-fcount');
        if (active) {
          if (!c) { c = document.createElement('span'); c.className = 'ok-fcount'; fbtn.appendChild(c); }
          c.textContent = active;
        } else if (c) c.remove();
      }

      // Un botón por filtro
      var bar = inner.querySelector('.ok-fpills');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ok-fpills';
        bar.setAttribute('role', 'group');
        bar.setAttribute('aria-label', ES ? 'Filtrar por' : 'Filter by');
        inner.appendChild(bar);
      }
      var html = '';
      sections().forEach(function (sec, i) {
        var n = boxes(sec).filter(function (b) { return b.checked; }).length;
        if (!boxes(sec).length && rangeOn(sec)) n = 1;
        // Precio: el botón suelto solo aparece si hay un precio aplicado (sigue dentro de "Filtros").
        if (!boxes(sec).length && !n) return;
        // 20/10/2026: si un filtro tiene una sola opción (ej. una sola categoría), no se muestra su botón.
        if (!n && boxes(sec).filter(function (b) { return !b.disabled; }).length < 2) return;
        html += '<button type="button" class="ok-fpill' + (n ? ' is-active' : '') + '" data-i="' + i + '" aria-haspopup="dialog" aria-expanded="' + (openIdx === i ? 'true' : 'false') + '">' +
          title(sec) + (n && boxes(sec).length ? ' <span class="ok-fpill__n">(' + n + ')</span>' : '') + CHEV + '</button>';
      });
      if (bar.getAttribute('data-sig') !== html) {
        bar.innerHTML = html;
        bar.setAttribute('data-sig', html);
        if (openIdx > -1) openBtn = bar.querySelector('[data-i="' + openIdx + '"]');
      }
      if (pop && pop.classList.contains('is-open')) fill();
    }

    function ensurePop() {
      if (pop) return;
      scrim = document.createElement('div');
      scrim.className = 'ok-fpop-scrim';
      scrim.addEventListener('click', close);
      pop = document.createElement('div');
      pop.className = 'ok-fpop';
      pop.setAttribute('role', 'dialog');
      pop.innerHTML = '<div class="ok-fpop__head"><span class="ok-fpop__t"></span><button type="button" class="ok-fpop__x" aria-label="' + (ES ? 'Cerrar' : 'Close') + '">' + X + '</button></div>' +
        '<div class="ok-fpop__body"></div>' +
        '<div class="ok-fpop__foot"><button type="button" class="ok-fpop__clear">' + (ES ? 'Limpiar' : 'Clear') + '</button><button type="button" class="ok-fpop__done">' + (ES ? 'Ver resultados' : 'Show results') + '</button></div>';
      document.body.appendChild(scrim);
      document.body.appendChild(pop);
      pop.querySelector('.ok-fpop__x').addEventListener('click', close);
      pop.querySelector('.ok-fpop__done').addEventListener('click', close);
      pop.querySelector('.ok-fpop__clear').addEventListener('click', function () {
        var sec = sections()[openIdx];
        if (!sec) return;
        var on = boxes(sec).filter(function (b) { return b.checked; });
        if (on.length) { busy(); on[0].click(); return; }
        var reset = sec.querySelector('.facets__reset, a[href*="filter"]');
        if (reset) reset.click();
      });
      pop.addEventListener('click', function (e) {
        var tb = e.target.closest('[data-szt], [data-szs]');
        if (tb) {
          e.stopPropagation();
          if (tb.hasAttribute('data-szt')) { szState.top = tb.getAttribute('data-szt'); szState.sub = null; }
          else szState.sub = tb.getAttribute('data-szs');
          fill();
          var bd = pop.querySelector('.ok-fpop__body'); if (bd) bd.scrollTop = 0;
          return;
        }
        var o = e.target.closest('.ok-fopt');
        if (!o || o.disabled) return;
        var sec = sections()[openIdx];
        var input = sec && boxes(sec)[+o.getAttribute('data-k')];
        if (!input) return;
        busy();
        o.setAttribute('aria-pressed', input.checked ? 'false' : 'true');
        input.click();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openIdx > -1) close(); });
      document.addEventListener('click', function (e) {
        if (openIdx < 0 || !e.isTrusted) return;
        // Si el elemento tocado se redibujó (pestañas de talles), no se cuenta como clic afuera
        if (!e.target.isConnected) return;
        if (pop.contains(e.target) || e.target.closest('.ok-fpill')) return;
        close();
      });
      // 01/11/2026: una vez por cuadro y solo con el desplegable abierto.
      var placeRaf = 0;
      function queuePlace() { if (openIdx < 0 || placeRaf) return; placeRaf = requestAnimationFrame(function () { placeRaf = 0; place(); }); }
      window.addEventListener('resize', queuePlace, { passive: true });
      window.addEventListener('scroll', queuePlace, { passive: true });
    }

    function busy() {
      pop.classList.add('is-busy');
      clearTimeout(busy.t);
      busy.t = setTimeout(function () { pop.classList.remove('is-busy'); }, 2500);
    }

    // Agrupa talles: zapatillas por Hombre (US) / Mujer (W) / Niños (Y, C, GS, PS, TD); ropa por letras y cintura; gorras y talle único aparte
    var szState = { top: null, sub: null };
    function szGroup(raw) {
      var t = raw.replace(/\s+/g, ' ').trim();
      var m = t.match(SPLIT);
      if (m) {
        var suf = (m[2] || '').toLowerCase();
        if (suf === 'w') return ['snk', 'w'];
        if (/^(y|c|k|gs|ps|td)$/.test(suf)) return ['snk', 'k'];
        return ['snk', 'm'];
      }
      if (/^\d+(\.\d)?\s*(us|m)$/i.test(t)) return ['snk', 'm'];
      if (/^\d+(\.\d)?\s*w$/i.test(t)) return ['snk', 'w'];
      if (/^\d+(\.\d)?\s*(y|c|gs|ps|td)$/i.test(t)) return ['snk', 'k'];
      if (/^(\d?x{0,3}s|s|m|l|x{1,3}l|\dxl)$/i.test(t)) return ['str', 'top'];
      if (/^(2[4-9]|3\d|4[0-4])$/.test(t)) return ['str', 'pant'];
      if (/^[6-8]( \d\/\d)?$/.test(t)) return ['acc', 'hat'];
      if (/^(os|one size|u|unico|único|talle único)$/i.test(t)) return ['acc', 'os'];
      return ['acc', 'other'];
    }
    var SZ_TOP = ES ? [['snk', 'Sneakers'], ['str', 'Streetwear'], ['acc', 'Accesorios']] : [['snk', 'Sneakers'], ['str', 'Apparel'], ['acc', 'Accessories']];
    var SZ_SUB = ES
      ? { snk: [['m', 'Hombre'], ['w', 'Mujer'], ['k', 'Niños']], str: [['top', 'Ropa'], ['pant', 'Pantalones · cintura']], acc: [['hat', 'Gorras'], ['os', 'Talle único'], ['other', 'Otros']] }
      : { snk: [['m', 'Men'], ['w', 'Women'], ['k', 'Kids']], str: [['top', 'Tops'], ['pant', 'Pants · waist']], acc: [['hat', 'Caps'], ['os', 'One size'], ['other', 'Other']] };
    function optHtml(b, k) {
      var raw = labelOf(b);
      var m = raw.match(SPLIT);
      var txt = m ? '<span class="ok-fopt__main">' + esc(m[1] + (m[2] ? ' ' + m[2].toUpperCase() : '')) + '</span><span class="ok-fopt__sub">' + esc(m[3].replace(/(\d)\s*cm/i, '$1 cm')) + '</span>'
        : '<span class="ok-fopt__main">' + esc(raw) + '</span>';
      return '<button type="button" class="ok-fopt" data-k="' + k + '" aria-pressed="' + (b.checked ? 'true' : 'false') + '"' + (b.disabled ? ' disabled' : '') + ' aria-label="' + esc(raw) + '">' + txt + '</button>';
    }
    function sizeGroups(list) {
      var g = {};
      list.forEach(function (b, k) {
        var c = szGroup(labelOf(b).replace(/\s*\(\d+\)\s*$/, ''));
        g[c[0]] = g[c[0]] || {};
        (g[c[0]][c[1]] = g[c[0]][c[1]] || []).push(k);
      });
      return g;
    }
    function groupedHtml(list) {
      var g = sizeGroups(list);
      var tops = SZ_TOP.filter(function (t) { return g[t[0]]; });
      var nSubs = tops.reduce(function (a, t) { return a + Object.keys(g[t[0]]).length; }, 0);
      if (nSubs < 2) return null;
      var sel = function (ks) { return ks.filter(function (k) { return list[k].checked; }).length; };
      var allK = function (top) { return Object.keys(g[top]).reduce(function (a, s) { return a.concat(g[top][s]); }, []); };
      if (!szState.top || !g[szState.top]) {
        var withSel = tops.filter(function (t) { return sel(allK(t[0])); })[0];
        var biggest = tops.slice().sort(function (a, b) { return allK(b[0]).length - allK(a[0]).length; })[0];
        szState.top = (withSel || biggest)[0];
        szState.sub = null;
      }
      var subs = SZ_SUB[szState.top].filter(function (s) { return g[szState.top][s[0]]; });
      if (szState.top === 'snk' && (!szState.sub || !g.snk[szState.sub])) {
        var sSel = subs.filter(function (s) { return sel(g.snk[s[0]]); })[0];
        szState.sub = (sSel || subs[0])[0];
      }
      var badge = function (n) { return n ? '<span class="ok-szt__n">' + n + '</span>' : ''; };
      var h = '';
      if (tops.length > 1) {
        h += '<div class="ok-szt" role="tablist" aria-label="' + (ES ? 'Tipo de talle' : 'Size type') + '">';
        tops.forEach(function (t) {
          h += '<button type="button" role="tab" data-szt="' + t[0] + '" aria-selected="' + (t[0] === szState.top) + '">' + t[1] + badge(sel(allK(t[0]))) + '</button>';
        });
        h += '</div>';
      }
      var wideGrid = function (ks) { return ks.some(function (k) { return SPLIT.test(labelOf(list[k])); }); };
      if (szState.top === 'snk') {
        if (subs.length > 1) {
          h += '<div class="ok-szs" role="tablist" aria-label="' + (ES ? 'Talles de zapatillas' : 'Sneaker sizes') + '">';
          subs.forEach(function (s) {
            h += '<button type="button" role="tab" data-szs="' + s[0] + '" aria-selected="' + (s[0] === szState.sub) + '">' + s[1] + badge(sel(g.snk[s[0]])) + '</button>';
          });
          h += '</div>';
        }
        var ks = g.snk[szState.sub];
        h += '<div class="ok-fpop__grid' + (wideGrid(ks) ? ' ok-fpop__grid--wide' : '') + '">' + ks.map(function (k) { return optHtml(list[k], k); }).join('') + '</div>';
      } else {
        subs.forEach(function (s) {
          var ks2 = g[szState.top][s[0]];
          if (subs.length > 1) h += '<div class="ok-szh">' + s[1] + '</div>';
          h += '<div class="ok-fpop__grid' + (wideGrid(ks2) ? ' ok-fpop__grid--wide' : '') + '">' + ks2.map(function (k) { return optHtml(list[k], k); }).join('') + '</div>';
        });
      }
      return h;
    }

    function fill() {
      var sec = sections()[openIdx];
      if (!sec) return close();
      pop.querySelector('.ok-fpop__t').textContent = title(sec);
      pop.setAttribute('aria-label', title(sec));
      var body = pop.querySelector('.ok-fpop__body');
      var list = boxes(sec);
      var html;
      var grouped = list.length && SIZE_LIKE.test(title(sec)) ? groupedHtml(list) : null;
      if (grouped) {
        if (body.getAttribute('data-sig') !== grouped) { body.innerHTML = grouped; body.setAttribute('data-sig', grouped); }
      } else if (list.length) {
        var grid = SIZE_LIKE.test(title(sec)) || list.every(function (b) { return labelOf(b).length <= 5; });
        var two = grid && list.some(function (b) { return SPLIT.test(labelOf(b)); });
        html = '<div class="' + (grid ? 'ok-fpop__grid' + (two ? ' ok-fpop__grid--wide' : '') : 'ok-fpop__list') + '">';
        list.forEach(function (b, k) {
          var raw = labelOf(b);
          var txt = esc(raw);
          if (grid) {
            var m = raw.match(SPLIT);
            if (m) txt = '<span class="ok-fopt__main">' + esc(m[1] + (m[2] ? ' ' + m[2].toUpperCase() : '')) + '</span><span class="ok-fopt__sub">' + esc(m[3].replace(/(\d)\s*cm/i, '$1 cm')) + '</span>';
            else txt = '<span class="ok-fopt__main">' + txt + '</span>';
          }
          html += '<button type="button" class="ok-fopt" data-k="' + k + '" aria-pressed="' + (b.checked ? 'true' : 'false') + '"' + (b.disabled ? ' disabled' : '') + ' aria-label="' + esc(raw) + '">' +
            (grid ? txt : '<span class="ok-fopt__box">' + CHECK + '</span><span>' + txt + '</span>') + '</button>';
        });
        html += '</div>';
        if (body.getAttribute('data-sig') !== html) { body.innerHTML = html; body.setAttribute('data-sig', html); }
      } else {
        // Precio u otros filtros con campos: se usa el contenido original del tema
        var content = sec.querySelector('.facets__accordion-body, .accordion__body, .accordion__content');
        if (content && content.parentNode !== body) {
          body.innerHTML = '';
          body.removeAttribute('data-sig');
          content.setAttribute('data-ok-home', '1');
          body.appendChild(content);
          pop._moved = { el: content, sec: sec };
        }
      }
      pop.classList.remove('is-busy');
      var anyOn = list.some(function (b) { return b.checked; });
      pop.querySelector('.ok-fpop__clear').hidden = list.length ? !anyOn : true;
    }

    function restoreMoved() {
      if (!pop || !pop._moved) return;
      var m = pop._moved;
      if (m.sec && m.sec.isConnected) m.sec.appendChild(m.el);
      pop._moved = null;
    }

    function place() {
      if (!pop || openIdx < 0 || !openBtn || !openBtn.isConnected) return;
      if (window.matchMedia('(max-width: 749px)').matches) return;
      var r = openBtn.getBoundingClientRect();
      var w = pop.offsetWidth;
      var left = Math.min(Math.max(16, r.left), window.innerWidth - w - 16);
      var top = Math.round(r.bottom + 8);
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
      pop.style.setProperty('--ok-pop-top', top + 'px');
    }

    function open(btn) {
      ensurePop();
      var i = +btn.getAttribute('data-i');
      if (openIdx === i) return close();
      restoreMoved();
      openIdx = i;
      openBtn = btn;
      szState = { top: null, sub: null };
      document.querySelectorAll('.ok-fpill').forEach(function (b) { b.setAttribute('aria-expanded', b === btn ? 'true' : 'false'); });
      fill();
      place();
      pop.classList.add('is-open');
      scrim.classList.add('is-open');
      pop.setAttribute('tabindex', '-1');
      setTimeout(function () { pop.focus({ preventScroll: true }); }, 60);
    }

    function close() {
      if (!pop) return;
      restoreMoved();
      pop.classList.remove('is-open', 'is-busy');
      scrim.classList.remove('is-open');
      document.querySelectorAll('.ok-fpill').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var back = openBtn;
      openIdx = -1;
      openBtn = null;
      if (back && back.isConnected && pop.contains(document.activeElement)) back.focus({ preventScroll: true });
    }

    function start() {
      headerOffset();
      build();
      document.addEventListener('click', function (e) {
        var b = e.target.closest('.ok-fpill');
        if (b) { e.preventDefault(); open(b); }
      });
      var t;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          if (pop && pop.contains(n)) continue;
          if (n.closest && n.closest('.ok-fpills')) continue;
          clearTimeout(t);
          t = setTimeout(build, 60);
          return;
        }
      }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled', 'value'] });
      document.addEventListener('change', function () { clearTimeout(t); t = setTimeout(build, 60); }, true);
      // 19/10/2026: una medición por cuadro (antes leía estilos y posiciones en cada evento de scroll).
      var hq = 0;
      function queueOffset() { if (!hq) hq = requestAnimationFrame(function () { hq = 0; headerOffset(); }); }
      window.addEventListener('resize', queueOffset, { passive: true });
      window.addEventListener('scroll', queueOffset, { passive: true });
      window.addEventListener('scrollend', queueOffset, { passive: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
